import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from 'src/viewLayer/components/App';

const root = createRoot(document.querySelector('[data-main]'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
